import { PayloadAction, createSlice } from "@reduxjs/toolkit";

const initialState = {
  companyMembers: [],
  companyMemberLoading: false,
};

const rolesSlice = createSlice({
  name: "rolesSlice", // slice name
  initialState, // initial state
  reducers: {
    // reducers
    setCompanyMembers(state, action: PayloadAction<any[]>) {
      state.companyMembers = action.payload;
    },
    setCompanyMemberLoading(state, action: PayloadAction<boolean>) {
      state.companyMemberLoading = action.payload;
    },
  },
});

export const { setCompanyMemberLoading, setCompanyMembers } =
  rolesSlice.actions;
export default rolesSlice.reducer;
